export default __webpack_public_path__ + "images/06808dac79d8e4fe4644d92bfb48e28f-emoji-hungry.svg";